import { useState } from 'preact/hooks';

const shapeName = (s) => (s.dotNumber || '').trim()
  ? `${s.dotType || ''} ${s.dotNumber}`.trim()
  : (s.dotType || 'Shape').trim();

export const ShapeTabs = ({ shapes, activeIdx, onSelect, onAdd, onRemove, onRename }) => {
  const [adding, setAdding] = useState(false);
  const [newType, setNewType] = useState('CRS');
  const [newNumber, setNewNumber] = useState('');

  const submitAdd = () => {
    onAdd({ dotType: newType.trim(), dotNumber: newNumber.trim(), weights: [] });
    setNewType('CRS'); setNewNumber(''); setAdding(false);
  };

  return (
    <div class="flex flex-wrap items-end gap-1 border-b border-border-subtle">
      {shapes.map((s, i) => (
        <button
          key={i}
          type="button"
          onClick={() => onSelect(i)}
          class={`flex items-center gap-2 px-3 py-2 text-[12px] font-medium ${
            i === activeIdx
              ? 'rounded-t-md bg-bg-card text-text-primary'
              : 'text-text-tertiary hover:text-text-primary'
          }`}
        >
          <span>{shapeName(s)}</span>
          {i === activeIdx && (
            <span
              role="button"
              tabIndex={0}
              onClick={(e) => { e.stopPropagation(); if (window.confirm(`Remove shape "${shapeName(s)}"?`)) onRemove(i); }}
              class="text-[10px] text-text-muted hover:text-ink-magenta"
              title="Remove shape"
            >×</span>
          )}
        </button>
      ))}
      {adding ? (
        <div class="flex items-center gap-1 px-2 py-1.5">
          <input
            class="w-16 rounded border border-border-strong bg-bg-card px-2 py-1 text-[11px]"
            value={newType} onInput={(e) => setNewType(e.currentTarget.value)}
            placeholder="CRS" autoFocus
          />
          <input
            class="w-16 rounded border border-border-strong bg-bg-card px-2 py-1 text-[11px]"
            value={newNumber} onInput={(e) => setNewNumber(e.currentTarget.value)}
            placeholder="501"
            onKeyDown={(e) => { if (e.key === 'Enter') submitAdd(); if (e.key === 'Escape') setAdding(false); }}
          />
          <button onClick={submitAdd} class="text-[11px] text-brand">Add</button>
          <button onClick={() => setAdding(false)} class="text-[11px] text-text-tertiary">×</button>
        </div>
      ) : (
        <button
          type="button"
          onClick={() => setAdding(true)}
          class="px-3 py-2 text-[12px] text-text-tertiary hover:text-text-primary"
        >+ Add shape</button>
      )}
    </div>
  );
};
